import { ClientQueryStatusEnum } from '../../types/client-query';
import { InternalCommentStatusEnum } from '../../types/internal-comment';
import { Worksheet, WorksheetTypeEnum } from '../../types/worksheet';
import { WorksheetChecklistItemStatusEnum } from '../../types/worksheet-checklist-item';

type OutstandingWork = { comments: number; queries: number; reviewConditions: number };

/**
 * For a given worksheet, get the number of remaining comments, queries and review conditions
 * @param worksheet
 * @returns OutstandingWork
 */
export function getOutstandingConditionFigures(worksheet: Worksheet): OutstandingWork {
    const outstandingComments = worksheet.internalComments.filter((ic) => ic.status !== InternalCommentStatusEnum.RESOLVED).length;
    const outstandingQueries = worksheet.clientQueries.filter((cq) => cq.status !== ClientQueryStatusEnum.RESOLVED).length;
    const outstandingChecklistItems = worksheet.checklist.filter((c) => c.status === WorksheetChecklistItemStatusEnum.UNCHECKED).length;
    const isUnreconciled = worksheet.type === WorksheetTypeEnum.RECONCILIATION && (worksheet.unreconciledCr || worksheet.unreconciledDr);

    // Total number of remaining conditions to be satisfied before a worksheet can be reviewed
    let outstandingReviewConditions = 0;

    if (isUnreconciled) {
        outstandingReviewConditions++;
    }

    if (outstandingComments) {
        outstandingReviewConditions++;
    }

    if (outstandingQueries) {
        outstandingReviewConditions++;
    }

    if (outstandingChecklistItems) {
        outstandingReviewConditions++;
    }

    return { comments: outstandingComments, queries: outstandingQueries, reviewConditions: outstandingReviewConditions };
}
